import $ from 'jquery';
import BalloonClass from '../common/BalloonClass';

/**
 * トリップアドバイザーの吹き出し
 */
export default class TripadvisorBalloonClass extends BalloonClass {
  constructor() {
    super();
    this.name = 'TripadvisorBalloonClass';
    this.balloonSelector = '.css_balloon.tripadvisor';
    this.clickSelector = '.js-balloon_tripadvisor';
  }

  onOpen(_target) {
    const href = _target.attr('href');
    if ($('iframe', this.balloon).attr('src') !== href) { $('iframe', this.balloon).attr({ src: href }); }
    super.onOpen(_target);
  }
}
